import { SVGProps } from 'react';

export const SvgClose = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill={props.fill ?? '#4C4C4C'}
                fillRule="evenodd"
                d="m12 13.414 5.656 5.657a1 1 0 0 0 1.414-1.414L13.413 12l5.657-5.657a1 1 0 0 0-1.414-1.414L12 10.586 6.342 4.929A1 1 0 0 0 4.93 6.343L10.585 12l-5.657 5.657a1 1 0 1 0 1.414 1.414L12 13.414Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
